<template src="./PageTable.html">

</template>

<script>
  import BaseTable from './BaseTable.vue'
  export default {
    name: "fpPageTable",
    components: {
      BaseTable
    },
    data() {
      return {
        currentPageSize: this.pageSize,
        currentPage: this.pageIndex,
        selectedArray: []
      }
    },
    props: {
      "defaultSort": {},
      "pageIndex": {
        type: Number,
        default: 1
      },
      "pageSize": {
        type: Number,
        default: 1
      },
      "cols": {
        type: Array,
        default: []
      },
      "pageDataSource": {
        type: Object,
        default: {
          totalRow: 0,
          list: []
        }
      },
      "selectType": {
        type: String,
      },
      "singleSelectTypeIcon": {
        type: String,
        default: "fa fa-edit"
      },
      "singleSelectText": {
        type: String,
        default: ""
      },
      "size": {
        type: String,
        default: "default"
      },
      "keyPath": {
        default: "id"
      }
    },
    methods: {
      handleClear(){
        this.selectedArray.forEach(t => {
          t.__selected = false;
        })
        this.selectedArray = [];
        this.$refs.table.clearSelection();
        this.$emit('onSelect', this.selectedArray);
      },
      handleSelect(args) {
        if (this.selectType == 'multiple' || this.selectType == 'both') {
          let arr = this.selectedArray.concat(args).filter(t => t.__selected);
          this.selectedArray = _.uniqBy(arr, this.keyPath);
          this.$emit('onSelect', this.selectedArray);
        } else {
          this.$emit('onSelect', args);
        }
      },
      handleSingleSelect(args) {
        this.$emit('onSingleSelect', args);
      },
      handleCommandSelect(args) {
        this.$emit('onCommandSelect', args);
      },
      handleSort(e) {
        this.$emit('onSort', e);
      },
      handlePageSizeChange(size) {
        this.handleClear();
        this.currentPageSize = size;
        this.$emit('onPage', {currentPage: this.currentPage, pageSize: this.currentPageSize});
      },
      handlePageChange(currentPage) {
        this.currentPage = currentPage;
        if (this.currentPage != this.pageIndex) {
          this.$emit('onPage', {currentPage: this.currentPage, pageSize: this.currentPageSize});
        }
      }
    },
    watch: {
      pageIndex(n, o){
        if (this.currentPage != n) {
          this.currentPage = n;
        }
      }
    },
    computed: {
      colsForPages() {
        let c = this.cols.map(t => {
          if (t.sortable === true) {
            t.sortable = "custom";
          }
          return t;
        });
        return c;
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// PageTable.vue?e775979e